// ADD: solo se encarga de ABRIR el modal con el producto principal
document.addEventListener('rebuy:cart.add', (event) => {
  let productHandle = event.detail.item.handle;

  if (window.hasModalCompleteSet === false) return;

  if (handleCompletetheLook === productHandle) {
    if ($('div#myModalCompleteLook').length) {
      $("#openModal").click();
      $("div#myModalCompleteLook #message-add-to-cart").fadeIn();
      $("div#myModalCompleteLook").addClass('open-modal-rebuy');
      setTimeout(function () {
        $(window).trigger('mcs:modal-opened');
      }, 450);
    }
  }
});

// CHANGE: actualiza la barra (trae el total ya recalculado)
document.addEventListener('rebuy:cart.change', (event) => {
  if (window.updateRewardsProgress && $('#myModalCompleteLook').hasClass('open-modal-rebuy')) {
    var totalPrice = event.detail.cart.cart.total_price;
    window.updateRewardsProgress(totalPrice);
  }
});